

// export const BASE_URL2 = 'http://www.apitp6.com'
// export const BASE_URL2 = 'https://uat-merapi2.aidogcatpet.com'
// export const BASE_URL2 = 'https://uat-merapi.aidogcatpet.com'
export const BASE_URL2 = 'https://merapi.aidogcatpet.com'

